<section class="grid min-h-full content-start gap-5">
  <h1 class="mb-4">Edycja wniosku</h1>

  @if (formGroup(); as formGroup) {
    <form class="grid gap-5" [formGroup]="formGroup">
      <section
        class="grid gap-6 rounded-xl border border-slate-200 bg-white p-4 shadow-sm md:p-6"
      >
        <h2 class="form-section-title m-0 leading-tight font-bold">
          Dane podstawowe
        </h2>

        <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div class="flex flex-col gap-2">
            <label for="code" appRequiredLabel="code" class="font-semibold"
              >Kod wniosku</label
            >
            <input
              pInputText
              id="code"
              class="w-full"
              [formControl]="formGroup.controls.code"
            />
          </div>

          <div class="flex flex-col gap-2">
            <label for="name" appRequiredLabel="name" class="font-semibold"
              >Nazwa</label
            >
            <input
              pInputText
              id="name"
              class="w-full"
              maxlength="1024"
              [formControl]="formGroup.controls.name"
              appControlError
            />
          </div>

          <div class="flex flex-col gap-2">
            <span id="areaLabel" appRequiredLabel="area" class="font-semibold"
              >Grupa</span
            >
            <p-select
              ariaLabelledBy="areaLabel"
              class="w-full"
              [options]="areaOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [formControl]="formGroup.controls.area"
              appControlError
            />
          </div>

          <div class="flex flex-col gap-2">
            <label
              for="technicalCode"
              appRequiredLabel="technicalCode"
              class="font-semibold"
              >Kod techniczny</label
            >
            <input
              pInputText
              id="technicalCode"
              class="w-full"
              [formControl]="formGroup.controls.technicalCode"
            />
          </div>

          <div class="flex flex-col gap-2">
            <span
              id="deletedLabel"
              appRequiredLabel="deleted"
              class="font-semibold"
              >Wniosek usunięty</span
            >
            <p-select
              ariaLabelledBy="deletedLabel"
              class="w-full"
              [options]="booleanOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [formControl]="formGroup.controls.deleted"
              appControlError
            />
          </div>
        </div>
      </section>

      <section
        class="grid gap-6 rounded-xl border border-slate-200 bg-white p-4 shadow-sm md:p-6"
      >
        <h2 class="form-section-title m-0 leading-tight font-bold">
          Widoczność i ograniczenia
        </h2>

        <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div class="flex flex-col gap-2">
            <span
              id="correspondenceLabel"
              appRequiredLabel="correspondenceEnabled"
              class="font-semibold"
              >Korespondencja</span
            >
            <p-select
              ariaLabelledBy="correspondenceLabel"
              class="w-full"
              [options]="booleanOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [formControl]="formGroup.controls.correspondenceEnabled"
              appControlError
            />
          </div>

          @if (formGroup.controls.visibleForAreas.disabled) {
            <div class="flex flex-col gap-2">
              <span appRequiredLabel="visibleForAreas" class="font-semibold"
                >Wyświetlaj dla obszarów</span
              >
              <textarea
                pInputTextarea
                class="w-full"
                rows="1"
                [autoResize]="true"
                [value]="visibleForAreasLabels() | valueOrDash"
                disabled
              ></textarea>
            </div>
          } @else {
            <div class="flex flex-col gap-2">
              <span
                id="visibleForAreasLabel"
                appRequiredLabel="visibleForAreas"
                class="font-semibold"
                >Wyświetlaj dla obszarów</span
              >
              <p-multiSelect
                ariaLabelledBy="visibleForAreasLabel"
                class="w-full"
                [options]="visibleForAreaOptions"
                [filter]="false"
                [showToggleAll]="false"
                optionLabel="label"
                optionValue="value"
                display="chip"
                appendTo="body"
                [formControl]="formGroup.controls.visibleForAreas"
              >
              </p-multiSelect>
            </div>
          }

          <div class="hidden md:block" aria-hidden="true"></div>

          <div class="flex flex-col gap-2">
            <span id="monthFromLabel" class="font-semibold">Miesiąc od</span>
            <p-select
              ariaLabelledBy="monthFromLabel"
              class="w-full"
              [options]="monthOptions"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              appendTo="body"
              [formControl]="formGroup.controls.monthFrom"
              [isInvalidCondition]="isRangeInvalid(formGroup.controls.monthFrom)"
              appControlError
            />
          </div>

          <div class="flex flex-col gap-2">
            <span id="monthToLabel" class="font-semibold">Miesiąc do</span>
            <p-select
              ariaLabelledBy="monthToLabel"
              class="w-full"
              [options]="monthOptions"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              appendTo="body"
              [formControl]="formGroup.controls.monthTo"
              [isInvalidCondition]="isRangeInvalid(formGroup.controls.monthTo)"
              appControlError
            />
          </div>

          <div class="hidden md:block" aria-hidden="true"></div>

          <div class="flex flex-col gap-2">
            <label for="dayFrom" class="font-semibold">Dzień od</label>
            <input
              pInputText
              id="dayFrom"
              type="number"
              class="w-full"
              step="1"
              [min]="1"
              [max]="31"
              [formControl]="formGroup.controls.dayFrom"
              [isInvalidCondition]="isRangeInvalid(formGroup.controls.dayFrom)"
              appControlError
            />
          </div>

          <div class="flex flex-col gap-2">
            <label for="dayTo" class="font-semibold">Dzień do</label>
            <input
              pInputText
              id="dayTo"
              type="number"
              class="w-full"
              step="1"
              [min]="1"
              [max]="31"
              [formControl]="formGroup.controls.dayTo"
              [isInvalidCondition]="isRangeInvalid(formGroup.controls.dayTo)"
              appControlError
            />
          </div>

          <div class="hidden md:block" aria-hidden="true"></div>
        </div>
      </section>

      <div class="mt-2 flex justify-end gap-3">
        <p-button
          type="button"
          styleClass="customInfoButton outlined"
          label="Anuluj"
          (click)="onCancel()"
        />
        <p-button
          type="button"
          styleClass="customInfoButton"
          label="Zapisz i zamknij"
          (click)="onSave()"
        />
      </div>
    </form>
  }
</section>
